var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_33_2",
    "data-name": "Component 33 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 262.947,
    height: 54.602,
    viewBox: "0 0 262.947 54.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(-1861.027 -1309.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1910.715,1364.073l-.078-32.762-16.068,26.99h-5.7l-15.99-26.287v32.059h-11.855v-54.6h10.451l20.437,33.93,20.125-33.93h10.373l.157,54.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1980.133,1309.472v54.6H1967.5v-22.387h-24.806v22.387h-12.635v-54.6h12.635V1331H1967.5v-21.528Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M2034.967,1329.284c0,12.168-9.127,19.734-23.713,19.734h-11v15.055h-12.637v-54.6h23.635C2025.84,1309.472,2034.967,1317.037,2034.967,1329.284Zm-12.793,0c0-6.007-3.9-9.517-11.621-9.517h-10.3v18.956h10.3C2018.276,1338.723,2022.174,1335.212,2022.174,1329.284Z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M2121,1320.2a46.209,46.209,0,0,0-5.71-10.73H2105.2c.33.329.64.669.95,1.009a5.773,5.773,0,0,1-1.86,9.071l-15.85,7.46a5.27,5.27,0,0,1-5.031-.36,11.691,11.691,0,0,0-17.29,6.29,5.253,5.253,0,0,1-3.62,3.51l-16.94,4.48a5.781,5.781,0,0,1-7.26-5.76,39.05,39.05,0,0,1,10.949-25.7h-10.09a46.7,46.7,0,0,0,.3,54.6h10.191a38.541,38.541,0,0,1-2.76-3.08,5.774,5.774,0,0,1,3.04-9.19l15.38-4.06a5.743,5.743,0,0,1,6.23,2.33l5.03,7.45,3.7,6.55h13.52a5.931,5.931,0,0,1-.75-2l-1.831-9.87-.939-8.951a5.741,5.741,0,0,1,3.27-5.78l14.391-6.78a5.794,5.794,0,0,1,7.239,1.96,5.688,5.688,0,0,1,1,3.12,38.968,38.968,0,0,1-11.369,28.3H2115A46.654,46.654,0,0,0,2121,1320.2Zm-41.11,23.681a7.786,7.786,0,1,1,4.66-9.981A7.788,7.788,0,0,1,2079.893,1343.883Z",
    transform: "translate(-1861.027 -1309.473)",
    fill: "#f2133c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.a9da10186d725ebf038684bce460f16a.svg";
export { ForwardRef as ReactComponent };